import { useSyncExternalStore } from 'react';

/**
 * Magasin des deux valeurs que la lecon envoie au manche : les notes du pas et
 * de la section (lessonNotes) et la frette la plus basse a viser (scrollToFret).
 * Hors de l'etat de App : un pas de lecon ne doit redessiner que le manche, pas
 * Learn, les pilules et le reste de l'ecran.
 */

const EMPTY = { notes: null, lowestFret: null };

let snapshot = EMPTY;
const listeners = new Set();

// Identites stables : useSyncExternalStore se reabonnerait a chaque rendu sinon.
const subscribe = (listener) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

const getSnapshot = () => snapshot;

// Publie seulement si une des deux valeurs change : l'instantane garde sa
// reference sinon, et aucun abonne ne se rend.
export const publishLessonNeck = (notes, lowestFret) => {
  if (snapshot.notes === notes && snapshot.lowestFret === lowestFret) return;
  snapshot = { notes, lowestFret };
  listeners.forEach((listener) => listener());
};

export const clearLessonNeck = () => publishLessonNeck(null, null);

export const readLessonNeck = () => snapshot;

export const useLessonNeck = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
